// Profile of Nikolai Genov, Spanish. Source of the profile page.
module.exports = {
  headline: 'AI & Data Science Lead • Salud, ciencias de la vida, finanzas',
  summary: 'Doctor en bioinformática y responsable técnico con implicación directa en el desarrollo, que combina la ingeniería de software asistida por IA con la analítica en entornos regulados de salud, ciencias de la vida y finanzas. Sus conocimientos especializados abarcan sistemas LLM/RAG, integración de MCP, datos clínicos, previsiones bancarias a cinco años y generación automatizada de informes en Excel. Aúna el desarrollo en R/Python con la coordinación de equipos, el aseguramiento de la calidad y talleres para la alta dirección; certificación en el AI Act y formación en GCP.',
  imageAlt: 'Retrato de Nikolai Genov',
  personal: {
    position: 'Cofundador y director general de pAIoneer Labs GmbH, director general de Leap Dynamics GmbH',
    location: 'Berlín, Alemania',
    languages: 'Alemán e inglés (fluidos), búlgaro (fluido)',
    programmingLanguages: 'R, Python, SQL/SQLite, SAS, MATLAB',
    certifications: 'Certificación en el AI Act, formación en GCP (2025)',
    publications: 'Trabajos científicos revisados por pares en Scientific Reports, PLOS Biology, IJMS, Frontiers in Physiology y PLOS ONE'
  },
  education: [
    {
      period: '2021',
      field: 'Doctorado: bioinformática / biología teórica',
      institution: '',
      degree: 'Título: doctor (Dr. rer. nat.)'
    },
    {
      period: '2015',
      field: 'Estudios: bioinformática',
      institution: 'Freie Universität Berlin',
      degree: 'Título: M.Sc. en bioinformática'
    },
    {
      period: '2012',
      field: 'Estudios: bioinformática',
      institution: 'Freie Universität Berlin',
      degree: 'Título: B.Sc. en bioinformática'
    }
  ],
  skills: [
    {
      title: 'Competencias clave',
      description: 'Desarrollo asistido por IA, R/Python, LLM/RAG y MCP, datos clínicos y bioinformática, previsiones y pruebas de estrés, informes en Excel, Shiny, liderazgo técnico'
    },
    {
      title: 'Programación y analítica',
      description: 'R, Python, SQL/SQLite, SAS, MATLAB; ggplot2, scikit-learn, Keras/TensorFlow'
    },
    {
      title: 'Aplicaciones e informes',
      description: 'R Shiny, Streamlit, Tableau, Leaflet, R Markdown, knitr, LaTeX; generación automatizada de informes en Excel/Word/PDF'
    },
    {
      title: 'IA e integración',
      description: 'OpenCode, ChatGPT, Model Context Protocol (MCP); Ollama, vLLM, LM Studio, Open WebUI, RAG, n8n, Flowise; desarrollo asistido por IA con revisión humana'
    },
    {
      title: 'Ingeniería',
      description: 'Azure DevOps, GitLab CI/CD, Docker, Camunda, Linux, Microsoft Azure, Google Cloud Platform'
    },
    {
      title: 'Bioinformática',
      description: 'RNA-seq, microarrays, splicing alternativo/isoformas, enriquecimiento de conjuntos de genes, análisis de rutas y redes, ensamblaje de genomas, análisis de supervivencia; Bioconductor, Cytoscape, GEO, ArrayExpress, Ensembl BioMart, UniProt/Swiss-Prot, GO, Reactome, KEGG, BioGRID, STRING, ChEMBL'
    },
    {
      title: 'Datos clínicos',
      description: 'EDC, CRF, edit checks, DMP, planes de validación de datos, UAT, conciliación de SAE; CDISC SDTM/ADaM, pipelines RAW/SDTM/ADaM, QC'
    }
  ],
  positions: [
    {
      period: '2022 - abril de 2024',
      title: 'Automatización de informes, T-Systems / Banco Central Europeo (BCE)',
      description: [
        'Desarrollo de una biblioteca de R para informes estadísticos sobre series temporales financieras; migración de la lógica FAME a R/Python con Reticulate y salidas automatizadas en Word/PDF.',
        'Desarrollo de pipelines para la generación automatizada de informes en Excel; integración de la analítica con Camunda y apoyo en GitLab CI/CD, pruebas unitarias, linting, SonarQube y documentación.',
        'Suplencia del responsable de equipo y participación en la planificación de sprints, la coordinación técnica, el aseguramiento de la calidad y la interlocución con las partes interesadas.'
      ]
    },
    {
      period: 'Junio de 2025 - diciembre de 2025',
      title: 'Data Science & Risk Analytics Consultant, banca',
      description: [
        'Desarrollo de modelos de previsión con horizontes de planificación de hasta cinco años e implementación de pruebas de estrés.',
        'Reescritura y refactorización de código R heredado, optimización de cuatro procesos de negocio y desarrollo asistido por IA con revisión humana para la implementación y la documentación.',
        'Creación de flujos de análisis en R/Shiny y de pipelines para la generación automatizada de informes en Excel; traducción de los requisitos de negocio en implementaciones analíticas.'
      ]
    },
    {
      period: 'Junio de 2025 - junio de 2026',
      title: 'Clinical Data Manager, industria farmacéutica / estudios clínicos',
      description: [
        'Gestión de la configuración de EDC, el diseño de CRF, los edit checks, los roles de usuario, las especificaciones de transferencia de datos y las UAT; coordinación con CRO, laboratorios y equipos de estudio.',
        'Elaboración y revisión de DMP, planes de validación, planes de conciliación de SAE y documentación de UAT; desarrollo de flujos de validación basados en R y de aplicaciones Shiny en un entorno relevante para GCP.'
      ]
    },
    {
      period: 'Julio de 2026',
      title: 'Pipeline de datos clínicos, Dr. Falk Pharma',
      description: [
        'Construcción de un pipeline RAW/SDTM/ADaM en R con OpenCode y desarrollo asistido por IA, con validación, QC, trazabilidad y pipelines automatizados de informes en Excel.'
      ]
    },
    {
      period: '2026',
      title: 'Informes de pista de auditoría asistidos por IA, Miltenyi Biotec',
      description: [
        'Implementación de informes de pista de auditoría y de pipelines automatizados de informes en Excel con OpenCode y desarrollo asistido por IA, incluidas la lógica de los informes, la depuración, la documentación y la revisión humana.'
      ]
    },
    {
      period: 'Desde 2019',
      title: 'Director general y cofundador / AI & Data Lead, Leap Dynamics GmbH',
      description: [
        'Dirección de la consultoría y de la ejecución técnica en salud, ciencias de la vida, finanzas e IA, combinando el desarrollo propio con la coordinación de equipos y la comunicación con las partes interesadas.',
        'Diseño de una infraestructura LLM/RAG y de la integración de herramientas basada en MCP. Implantación de flujos de trabajo en R/Python asistidos por OpenCode para la generación de código, la refactorización, las pruebas y la documentación con revisión humana.'
      ]
    },
    {
      period: 'Desde 2022',
      title: 'Registro de cáncer y biobanco, Medical University Pleven',
      description: [
        'Análisis de datos del registro nacional de cáncer y creación de paneles Shiny para partes interesadas clínicas y de investigación; apoyo a la integración, la documentación y los flujos de trabajo del biobanco para cinco tipos de cáncer.'
      ]
    },
    {
      period: 'Desde 2025',
      title: 'Lead Developer, AI Map Europe (ai-map.eu)',
      description: [
        'Desarrollo de una aplicación R Shiny lista para producción; migración de los datos de CSV a SQLite e incorporación de autenticación de administrador, gestión de instituciones, analítica de visitantes, listados de pago y formularios de consulta con notificaciones SMTP.',
        'Mejora de la UI/UX adaptable, el SEO, los datos estructurados y la compatibilidad con sitemap/robots; incorporación de validación de entradas, escapado de salidas, limitación de intentos de inicio de sesión y publicación exclusiva de registros verificados. Auditoría de más de 400 instituciones a partir de ELLIS, CAIRNE, AI NATION, NET4AI, INSAIT y AI-on-Demand, con documentación de procedencia y documentación de despliegue y seguridad.'
      ]
    },
    {
      period: 'Desde 2024',
      title: 'Análisis de noticias financieras basado en LLM, Leap Dynamics (proyecto interno)',
      description: [
        'Creación de flujos recurrentes de análisis de sentimiento con LLM, datos de API, informes PDF automatizados, una interfaz Streamlit, orquestación con n8n y pruebas de flujos de trabajo con apoyo de Flowise.'
      ]
    },
    {
      period: '2025',
      title: 'Talleres para la alta dirección, BVMW',
      description: [
        'Impartición de talleres para participantes de la alta dirección en la red BVMW.'
      ]
    },
    {
      period: '2015 - 2019',
      title: 'Colaborador científico, Humboldt-Universität / Charité, Berlín',
      description: []
    },
    {
      period: '2015 - 2017',
      title: 'CTO y cofundador, Promethano GmbH',
      description: [
        'Software para ciencias de la vida y aplicaciones de series temporales.'
      ]
    }
  ]
};
